import { UserButton } from "@clerk/react";
import { useMe } from "@/context/MeContext";
import { Clock } from "lucide-react";

export default function PendingAccess() {
  const { me, reload } = useMe();
  return (
    <div className="on-navy hero-band min-h-screen relative overflow-hidden flex items-center" data-testid="pending-access-page">
      <img src="/hero-jet.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 hero-overlay" />
      <div className="absolute top-6 right-6 z-10"><UserButton /></div>
      <div className="relative z-10 max-w-xl px-6 sm:px-14 rise">
        <img src="/brand/logo-silver.png" alt="JetSet Group Inc" className="h-24 w-auto mb-14" />
        <Clock className="text-[#C6A55C] mb-6" size={28} strokeWidth={1.2} />
        <p className="eyebrow mb-3">Awaiting approval</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl text-white leading-tight">Your access is being reviewed.</h1>
        <p className="mt-5 text-zinc-300 text-sm sm:text-base leading-relaxed">
          You're signed in as <span className="text-white">{me?.email}</span>. A JetSet Group admin needs to approve
          your account before you can see trip requests. If you were invited, make sure you signed up with the email
          address your invitation was sent to.
        </p>
        <button className="frame-btn mt-10" onClick={reload} data-testid="pending-check-again-btn">Check again</button>
      </div>
    </div>
  );
}
